export default __webpack_public_path__ + "static/media/03_cart.a6565b4b.svg";